module.exports = __webpack_public_path__ + "media/images/strategic-partners/flexscan-696863a8a4822fed10850d6c24253233.jpeg";